import React from 'react';
import { Eye, EyeOff, Link as LinkIcon } from 'lucide-react';

const HiddenAffiliatePage: React.FC = () => {
  return (
    <div className="pt-24 pb-16">
      {/* Warning Header */}
      <section className="bg-red-600 text-white py-4">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-center">
            <EyeOff className="w-5 h-5 mr-2" />
            <p className="text-sm font-medium">
              VERSTECKTE SEITE - Nur für interne Zwecke - Nicht für Kunden sichtbar
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-lg shadow-md p-8">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                  <LinkIcon className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <h1 className="text-2xl font-bold text-gray-800">Affiliate Tracking</h1>
                  <p className="text-gray-600">Versteckte Seite für Affiliate-Links und Tracking-Code</p>
                </div>
              </div>

              {/* Info Box */}
              <div className="mb-8 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                <div className="flex items-center">
                  <Eye className="w-5 h-5 text-yellow-600 mr-2" />
                  <p className="text-yellow-800 text-sm font-medium">
                    <strong>Hinweis:</strong> Diese Seite ist nur über die direkte URL erreichbar und wird nicht in der Navigation angezeigt.
                  </p>
                </div>
              </div>

              {/* Affiliate Code Section */}
              <div className="mb-8">
                <h2 className="text-xl font-bold text-gray-800 mb-4">Handys mit Vertrag - Affiliate Link</h2>
                <div className="bg-gray-50 rounded-lg p-6">
                  <p className="text-sm text-gray-600 mb-4">
                    Dieser Code wird für Affiliate-Tracking verwendet:
                  </p>
                  
                  {/* Der eingebettete HTML-Code */}
                  <div className="border border-gray-200 rounded-lg p-4 bg-white mb-4">
                    <h4 className="text-sm font-medium text-gray-700 mb-2">Handys mit Vertrag:</h4>
                    <div 
                      id="gba_huGw"
                      dangerouslySetInnerHTML={{
                        __html: '<a href="https://ndirect.ppro.de/click/huGw" >Handys mit Vertrag</a><img border="0" src="https://ndirect.ppro.de/image/huGw"/>'
                      }}
                    />
                  </div>

              {/* Handy Bundle Link */}
              <div className="border border-gray-200 rounded-lg p-4 bg-white mb-4">
                <h4 className="text-sm font-medium text-gray-700 mb-2">Handy Bundle:</h4>
                <div 
                  id="gba_huGw_bundle"
                  dangerouslySetInnerHTML={{
                    __html: '<a href="https://ndirect.ppro.de/click/huGw" >Handys mit Vertrag</a><img border="0" src="https://ndirect.ppro.de/image/huGw"/>'
                  }}
                />
              </div>

              {/* Gomibo Affiliate Link */}
              <div className="border border-gray-200 rounded-lg p-4 bg-white mb-4">
                <h4 className="text-sm font-medium text-gray-700 mb-2">Gomibo (Handys mit Vertrag):</h4>
                <div className="mb-3">
                  <div 
                    id="gba_huGw_gomibo"
                    dangerouslySetInnerHTML={{
                      __html: '<a href="https://ndirect.ppro.de/click/huGw" target="_blank" class="inline-flex items-center px-4 py-2 bg-cyan-500 text-white rounded-lg hover:bg-cyan-600 transition-colors">🔗 Gomibo</a><img border="0" src="https://ndirect.ppro.de/image/huGw"/>'
                    }}
                  />
                </div>
                <div className="text-xs text-gray-500 bg-gray-50 p-2 rounded">
                  <strong>Affiliate-ID:</strong> huGw<br/>
                  <strong>Click-URL:</strong> https://ndirect.ppro.de/click/huGw<br/>
                  <strong>Pixel-URL:</strong> https://ndirect.ppro.de/image/huGw<br/>
                  <strong>Angebot:</strong> Handys mit Vertrag (Gomibo)
                </div>
              </div>

              {/* Sparhandy Affiliate Link */}
              <div className="border border-gray-200 rounded-lg p-4 bg-white mb-4">
                <h4 className="text-sm font-medium text-gray-700 mb-2">Sparhandy (Nur für interne Nutzung):</h4>
                <div className="mb-3">
                  <a 
                    href="https://www.communicationads.net/tc.php?t=18676C19328154B"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors"
                  >
                    🔗 Sparhandy Affiliate Link
                  </a>
                </div>
                <div className="text-xs text-gray-500 bg-gray-50 p-2 rounded">
                  <strong>URL:</strong> https://www.communicationads.net/tc.php?t=18676C19328154B<br/>
                  <strong>Tracking-ID:</strong> 18676C19328154B
                </div>
              </div>

              {/* sim.de Affiliate Link */}
              <div className="border border-gray-200 rounded-lg p-4 bg-white mb-4">
                <h4 className="text-sm font-medium text-gray-700 mb-2">sim.de (Nur für interne Nutzung):</h4>
                <div className="mb-3">
                  <a 
                    href="https://www.communicationads.net/tc.php?t=18676C12926445T"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
                  >
                    🔗 sim.de Affiliate Link
                  </a>
                </div>
                <div className="text-xs text-gray-500 bg-gray-50 p-2 rounded">
                  <strong>URL:</strong> https://www.communicationads.net/tc.php?t=18676C12926445T<br/>
                  <strong>Tracking-ID:</strong> 18676C12926445T<br/>
                  <strong>Pixel-URL:</strong> https://www.communicationads.net/tb.php?t=18676V12926445T<br/>
                  <strong>Typ:</strong> sim.de D-Netz Tarife
                </div>
              </div>

              {/* logitel.de Affiliate Link */}
              <div className="border border-gray-200 rounded-lg p-4 bg-white mb-4">
                <h4 className="text-sm font-medium text-gray-700 mb-2">logitel.de (Nur für interne Nutzung):</h4>
                <div className="mb-3">
                  <a 
                    href="https://www.communicationads.net/tc.php?t=18676C14328457B"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-4 py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600 transition-colors"
                  >
                    🔗 logitel.de Affiliate Link
                  </a>
                </div>
                <div className="text-xs text-gray-500 bg-gray-50 p-2 rounded">
                  <strong>URL:</strong> https://www.communicationads.net/tc.php?t=18676C14328457B<br/>
                  <strong>Tracking-ID:</strong> 18676C14328457B
                </div>
              </div>

              {/* DeinHandy.de Affiliate Link */}
              <div className="border border-gray-200 rounded-lg p-4 bg-white mb-4">
                <h4 className="text-sm font-medium text-gray-700 mb-2">DeinHandy.de (Nur für interne Nutzung):</h4>
                <div className="mb-3">
                  <a 
                    href="https://www.communicationads.net/tc.php?t=18676C13423302T"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-4 py-2 bg-teal-500 text-white rounded-lg hover:bg-teal-600 transition-colors"
                  >
                    🔗 DeinHandy.de Affiliate Link
                  </a>
                </div>
                <div className="text-xs text-gray-500 bg-gray-50 p-2 rounded">
                  <strong>URL:</strong> https://www.communicationads.net/tc.php?t=18676C13423302T<br/>
                  <strong>Tracking-ID:</strong> 18676C13423302T
                </div>
              </div>

              {/* Bundle-Rechner Affiliate Link */}
              <div className="border border-gray-200 rounded-lg p-4 bg-white mb-4">
                <h4 className="text-sm font-medium text-gray-700 mb-2">Bundle-Rechner (Nur für interne Nutzung):</h4>
                <div className="mb-3">
                  <a 
                    href="https://tools.communicationads.net/calc.php?cl=bundle&wf=18676&country=DE"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-4 py-2 bg-indigo-500 text-white rounded-lg hover:bg-indigo-600 transition-colors"
                  >
                    🔗 Bundle-Rechner
                  </a>
                </div>
                <div className="text-xs text-gray-500 bg-gray-50 p-2 rounded">
                  <strong>URL:</strong> https://tools.communicationads.net/calc.php?cl=bundle&wf=18676&country=DE<br/>
                  <strong>Typ:</strong> Bundle-Vergleichsrechner<br/>
                  <strong>Workflow-ID:</strong> 18676
                </div>
              </div>

              {/* Samsung S25 Ultra + Vodafone Affiliate Link */}
              <div className="border border-gray-200 rounded-lg p-4 bg-white mb-4">
                <h4 className="text-sm font-medium text-gray-700 mb-2">Samsung S25 Ultra + 100GB Vodafone (Helden):</h4>
                <div className="mb-3">
                  <div 
                    id="gba_o6WF"
                    dangerouslySetInnerHTML={{
                      __html: '<a href="https://ndirect.ppro.de/click/o6WF" target="_blank" class="inline-flex items-center px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors">🔗 Samsung S25 Ultra + 100GB Vodafone</a><img border="0" src="https://ndirect.ppro.de/image/o6WF"/>'
                    }}
                  />
                </div>
                <div className="text-xs text-gray-500 bg-gray-50 p-2 rounded">
                  <strong>Affiliate-ID:</strong> o6WF<br/>
                  <strong>Click-URL:</strong> https://ndirect.ppro.de/click/o6WF<br/>
                  <strong>Pixel-URL:</strong> https://ndirect.ppro.de/image/o6WF<br/>
                  <strong>Angebot:</strong> Samsung S25 Ultra + 100GB Vodafone Tarif
                </div>
              </div>

             {/* Red Bull E-Scooter + Samsung A16 Bundle Affiliate Link */}
             <div className="border border-gray-200 rounded-lg p-4 bg-white mb-4">
               <h4 className="text-sm font-medium text-gray-700 mb-2">Red Bull E-Scooter + Samsung A16 Bundle:</h4>
               <div className="mb-3">
                 <div 
                   id="gba_nsM2"
                   dangerouslySetInnerHTML={{
                     __html: '<a href="https://ndirect.ppro.de/click/nsM2" target="_blank" class="inline-flex items-center px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">🛴 Red Bull E-Scooter + Samsung A16 Bundle</a><img border="0" src="https://ndirect.ppro.de/image/nsM2"/>'
                   }}
                 />
               </div>
               <div className="text-xs text-gray-500 bg-gray-50 p-2 rounded">
                 <strong>Affiliate-ID:</strong> nsM2<br/>
                 <strong>Click-URL:</strong> https://ndirect.ppro.de/click/nsM2<br/>
                 <strong>Pixel-URL:</strong> https://ndirect.ppro.de/image/nsM2<br/>
                 <strong>Angebot:</strong> Red Bull E-Scooter + Samsung A16 Bundle
               </div>
             </div>

             {/* THG-Quote Affiliate Link */}
             <div className="border border-gray-200 rounded-lg p-4 bg-white mb-4">
               <h4 className="text-sm font-medium text-gray-700 mb-2">THG-Quote (Nur für interne Nutzung):</h4>
               <div className="mb-3">
                 <a 
                   href="https://tools.communicationads.net/calc.php?cl=thg&wf=18676&country=DE"
                   target="_blank"
                   rel="noopener noreferrer"
                   className="inline-flex items-center px-4 py-2 bg-emerald-500 text-white rounded-lg hover:bg-emerald-600 transition-colors"
                 >
                   🔗 THG-Quote
                 </a>
               </div>
               <div className="text-xs text-gray-500 bg-gray-50 p-2 rounded">
                 <strong>URL:</strong> https://tools.communicationads.net/calc.php?cl=thg&wf=18676&country=DE<br/>
                 <strong>Typ:</strong> THG-Quote Rechner<br/>
                 <strong>Workflow-ID:</strong> 18676
               </div>
             </div>

              {/* Banner Link */}
              <div className="border border-gray-200 rounded-lg p-4 bg-white mb-4">
                <h4 className="text-sm font-medium text-gray-700 mb-2">Banner Link (Nur für interne Nutzung):</h4>
                <div className="mb-3">
                  <a 
                    href="https://www.communicationads.net/tc.php?t=18676C42647628B"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-lg hover:from-blue-600 hover:to-purple-600 transition-colors"
                  >
                    🔗 Banner Link
                  </a>
                </div>
                <div className="text-xs text-gray-500 bg-gray-50 p-2 rounded">
                  <strong>URL:</strong> https://www.communicationads.net/tc.php?t=18676C42647628B<br/>
                  <strong>Tracking-ID:</strong> 18676C42647628B<br/>
                  <strong>Typ:</strong> Banner Link
                </div>
              </div>

              {/* Neuer Affiliate Link */}
              <div className="border border-gray-200 rounded-lg p-4 bg-white mb-4">
                <h4 className="text-sm font-medium text-gray-700 mb-2">Neuer Affiliate Link (Nur für interne Nutzung):</h4>
                <div className="mb-3">
                  <a 
                    href="https://www.communicationads.net/tc.php?t=18676C45047944B"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-green-500 to-teal-500 text-white rounded-lg hover:from-green-600 hover:to-teal-600 transition-colors"
                  >
                    🔗 Neuer Affiliate Link
                  </a>
                </div>
                <div className="text-xs text-gray-500 bg-gray-50 p-2 rounded">
                  <strong>URL:</strong> https://www.communicationads.net/tc.php?t=18676C45047944B<br/>
                  <strong>Tracking-ID:</strong> 18676C45047944B<br/>
                  <strong>Typ:</strong> Affiliate Link
                </div>
              </div>
              {/* Samsung Banner Link */}
              <div className="border border-gray-200 rounded-lg p-4 bg-white mb-4">
                <h4 className="text-sm font-medium text-gray-700 mb-2">Samsung Galaxy AI Banner (Mit Foto):</h4>
                <div className="mb-3">
                  <a 
                    href="https://www.communicationads.net/tc.php?t=18676C42647630B"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg hover:from-blue-700 hover:to-purple-700 transition-colors"
                  >
                    🤖 Samsung Galaxy AI Banner
                  </a>
                </div>
                <div className="text-xs text-gray-500 bg-gray-50 p-2 rounded mb-3">
                  <strong>Click-URL:</strong> https://www.communicationads.net/tc.php?t=18676C42647630B<br/>
                  <strong>Image-URL:</strong> /Bildschirmfoto 2025-10-31 um 22.53.33.png<br/>
                  <strong>Tracking-ID:</strong> 18676C42647630B<br/>
                  <strong>Typ:</strong> Samsung Galaxy AI Banner (Vollbreite)
                </div>
                <div className="border border-gray-300 rounded p-2 bg-white">
                  <img 
                    src="/Bildschirmfoto 2025-10-31 um 22.53.33.png" 
                    alt="Samsung Galaxy AI Banner Preview" 
                    className="max-w-full h-auto rounded"
                    style={{ maxWidth: '300px', height: 'auto' }}
                  />
                  <p className="text-xs text-gray-500 mt-1">Banner Vorschau (verkleinert)</p>
                </div>
              </div>

              {/* MediaMarkt/Saturn Banner Link */}
              <div className="border border-gray-200 rounded-lg p-4 bg-white mb-4">
                <h4 className="text-sm font-medium text-gray-700 mb-2">MediaMarkt/Saturn Banner (Mit Foto):</h4>
                <div className="mb-3">
                  <a 
                    href="https://rast.mediamarkt.de/tc.php?t=18676C20940882B"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-red-600 to-gray-800 text-white rounded-lg hover:from-red-700 hover:to-gray-900 transition-colors"
                  >
                    🛍️ MediaMarkt/Saturn Banner
                  </a>
                </div>
                <div className="text-xs text-gray-500 bg-gray-50 p-2 rounded mb-3">
                  <strong>Click-URL:</strong> https://rast.mediamarkt.de/tc.php?t=18676C20940882B<br/>
                  <strong>Image-URL:</strong> /Bildschirmfoto 2025-10-31 um 23.04.24.png<br/>
                  <strong>Tracking-ID:</strong> 18676C20940882B<br/>
                  <strong>Typ:</strong> MediaMarkt/Saturn Banner (Vollbreite)
                </div>
                <div className="border border-gray-300 rounded p-2 bg-white">
                  <img 
                    src="/Bildschirmfoto 2025-10-31 um 23.04.24.png" 
                    alt="MediaMarkt/Saturn Banner Preview" 
                    className="max-w-full h-auto rounded"
                    style={{ maxWidth: '300px', height: 'auto' }}
                  />
                  <p className="text-xs text-gray-500 mt-1">Banner Vorschau (verkleinert)</p>
                </div>
              </div>
                  {/* Code Display */}
                  <div className="bg-gray-900 text-green-400 p-4 rounded-lg font-mono text-sm overflow-x-auto">
                    <code>
                  {`<!-- Handys mit Vertrag -->
<div id="gba_huGw"><a href="https://ndirect.ppro.de/click/huGw" >Handys mit Vertrag</a><img border="0" src="https://ndirect.ppro.de/image/huGw"/></div>

<!-- Handy Bundle -->
<div id="gba_huGw_bundle"><a href="https://ndirect.ppro.de/click/huGw" >Handys mit Vertrag</a><img border="0" src="https://ndirect.ppro.de/image/huGw"/></div>

<!-- Gomibo (Handys mit Vertrag) -->
<div id="gba_huGw_gomibo"><a href="https://ndirect.ppro.de/click/huGw" >Gomibo</a><img border="0" src="https://ndirect.ppro.de/image/huGw"/></div>

<!-- Samsung S25 Ultra + 100GB Vodafone (Helden) -->
<div id="gba_o6WF"><a href="https://ndirect.ppro.de/click/o6WF" >Samsung S25 Ultra + 100GB Vodafone</a><img border="0" src="https://ndirect.ppro.de/image/o6WF"/></div>

<!-- Red Bull E-Scooter + Samsung A16 Bundle -->
<div id="gba_nsM2"><a href="https://ndirect.ppro.de/click/nsM2" >Red Bull E-Scooter + Samsung A16 Bundle</a><img border="0" src="https://ndirect.ppro.de/image/nsM2"/></div>

<!-- Sparhandy Affiliate Links (Nur intern) -->
<a href="https://www.communicationads.net/tc.php?t=18676C19328154B" target="_blank">
  Sparhandy Affiliate Link
</a>

<!-- sim.de Affiliate Link (Nur intern) -->
<a href="https://www.communicationads.net/tc.php?t=18676C12926445T" target="_blank">
  sim.de Affiliate Link
</a>

<!-- logitel.de Affiliate Link (Nur intern) -->
<a href="https://www.communicationads.net/tc.php?t=18676C14328457B" target="_blank">
  logitel.de Affiliate Link
</a>

<!-- DeinHandy.de Affiliate Link (Nur intern) -->
<a href="https://www.communicationads.net/tc.php?t=18676C13423302T" target="_blank">
  DeinHandy.de Affiliate Link
</a>

<!-- THG-Quote (Nur intern) -->
<a href="https://tools.communicationads.net/calc.php?cl=thg&wf=18676&country=DE" target="_blank">
  THG-Quote
</a>

<!-- Bundle-Rechner (Nur intern) -->
<a href="https://tools.communicationads.net/calc.php?cl=bundle&wf=18676&country=DE" target="_blank">
  Bundle-Rechner
</a>

<!-- Banner Link (Nur intern) -->
<a href="https://www.communicationads.net/tc.php?t=18676C42647628B" target="_blank">
  Banner Link
</a>

<!-- Samsung Galaxy AI Banner (Mit Foto) -->
<a href="https://www.communicationads.net/tc.php?t=18676C42647630B" target="_blank">
  <img src="/Bildschirmfoto 2025-10-31 um 22.53.33.png" alt="Samsung Galaxy AI - Dein Galaxy. Dein Tarif." border="0" style="max-width: 100%; height: auto;">
</a>

<!-- MediaMarkt/Saturn Banner (Mit Foto) -->
<a href="https://rast.mediamarkt.de/tc.php?t=18676C20940882B" target="_blank">
  <img src="/Bildschirmfoto 2025-10-31 um 23.04.24.png" alt="MediaMarkt & Saturn - Technik-Highlights" border="0" style="max-width: 100%; height: auto;">
</a>

<!-- Sparhandy Banner (Mit Foto) -->
<a href="https://www.communicationads.net/tc.php?t=18676C19328154B" target="_blank">
  <img src="/Bildschirmfoto 2025-10-31 um 23.13.44.png" alt="Sparhandy - Handys mit Vertrag" border="0" style="max-width: 100%; height: auto;">
</a>

<!-- SparSIM Halloween Banner (Mit Foto) -->
<a href="https://www.communicationads.net/tc.php?t=18676C45047944B" target="_blank">
  <img src="/Bildschirmfoto 2025-10-31 um 20.33.12.png" alt="SparSIM Halloween Angebot" border="0" style="max-width: 100%; height: auto;">
</a>`}
                    </code>

                  </div>
                </div>
              </div>

              {/* Statistics Section */}
              <div className="mb-8">
                <h2 className="text-xl font-bold text-gray-800 mb-4">Tracking-Informationen</h2>
                <div className="grid md:grid-cols-3 gap-4">
                  <div className="bg-blue-50 p-4 rounded-lg">
                    <h3 className="font-medium text-blue-800">Affiliate ID</h3>
                    <p className="text-blue-600 font-mono">huGw</p>
                  </div>
                  <div className="bg-green-50 p-4 rounded-lg">
                    <h3 className="font-medium text-green-800">Tracking URL</h3>
                    <p className="text-green-600 text-sm break-all">ndirect.ppro.de/click/huGw<br/>communicationads.net (Sparhandy)</p>
                  </div>
                  <div className="bg-purple-50 p-4 rounded-lg">
                    <h3 className="font-medium text-purple-800">Pixel URL</h3>
                    <p className="text-purple-600 text-sm break-all">ndirect.ppro.de/image/huGw<br/>ndirect.ppro.de/image/o6WF (Samsung S25 Ultra)<br/>ndirect.ppro.de/image/nsM2 (Red Bull E-Scooter + Samsung A16)<br/>18676C19328056T (Sparhandy Alt)<br/>18676C12926445T (sim.de)<br/>18676C14328457B (logitel.de)<br/>18676C13423302T (DeinHandy.de)<br/>18676 (THG-Quote)</p>
                  </div>
                </div>
              </div>

              {/* Access Information */}
              <div className="bg-gray-50 rounded-lg p-6">
                <h3 className="text-lg font-bold text-gray-800 mb-3">Zugriffsinformationen</h3>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• <strong>URL:</strong> /hidden-affiliate (nur über direkte Eingabe erreichbar)</li>
                  <li>• <strong>Navigation:</strong> Nicht in Menüs oder Sitemaps enthalten</li>
                  <li>• <strong>SEO:</strong> Nicht von Suchmaschinen indexiert</li>
                  <li>• <strong>Zweck:</strong> Affiliate-Tracking und interne Verwaltung</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HiddenAffiliatePage;